// Arabic catalog — the source of truth. Keys are dot-paths; English must define every key (test enforces).
// Terminology follows the PRD glossary (02-product-requirements.md §0.3, OD-35).
export const ar = {
    /** Display names for stored codes (folio lines, revenue groups, …). Screens read them via code(), which
     *  falls back to the raw code instead of leaking a dotted key. */
    codes: {
        reasonText: {
            inspectionPassed: 'نجح الفحص',
            initialSetup: 'إعداد أولي',
            occupiedNeedsService: 'التدقيق الليلي: غرفة مشغولة تحتاج خدمة',
            nightAuditDate: 'التدقيق الليلي {{date}}',
            overrideCheck: 'تجاوز الفحص {{check}} في التدقيق الليلي',
            ticketResolved: 'حُلّت تذكرة الصيانة',
            ticket: 'تذكرة صيانة: {{text}}',
            maintenance: 'صيانة: {{text}}',
            transfer: 'تحويل',
            mistake: 'خطأ إدخال',
            nonPayment: 'عدم الدفع',
            unknownBooking: 'حجز غير معروف',
            noReservation: 'لا يوجد حجز مقابل لهذا الطلب',
            expired: 'انتهت المهلة',
            endedByHotel: 'أنهاه الفندق',
            registration: 'التسجيل',
            guestRequest: 'طلب النزيل',
        },
        level: {
            info: 'معلومة',
            warning: 'تحذير',
            critical: 'حرج',
        },
        actorKind: {
            user: 'مستخدم',
            system: 'النظام',
            cloud_command: 'أمر من السحابة',
            support: 'الدعم',
            staff: 'فريق سيروفا',
            channel: 'القنوات',
            node: 'خادم الفندق',
            owner: 'المالك',
            tenant_user: 'مستخدم البوابة',
        },
        status: {
            active: 'نشط',
            suspended: 'موقوف',
            closed: 'مغلق',
            disabled: 'معطّل',
            provisioned: 'بانتظار التفعيل',
            retired: 'متقاعد',
            superseded: 'مُستبدل',
            revoked: 'مُلغى',
            requested: 'مطلوب',
            approved: 'موافق عليه',
            expired: 'منتهٍ',
            rejected: 'مرفوض',
            held: 'محجوز مؤقتاً',
            confirmed: 'مؤكد',
            accepted: 'مقبول',
            cancelled: 'ملغى',
            open: 'مفتوح',
            in_progress: 'قيد المعالجة',
            waiting_hotel: 'بانتظار الفندق',
            resolved: 'محلول',
            ok: 'ناجح',
            failed: 'فاشل',
            running: 'جارٍ',
            pending: 'معلّق',
        },
        role: {
            staff_admin: 'مدير التشغيل',
            ops: 'التشغيل',
            support: 'الدعم',
            sales: 'المبيعات',
            tenant_admin: 'مدير',
            viewer: 'مشاهد',
        },
        releaseKind: {
            release: 'إصدار',
            hotfix: 'إصلاح عاجل',
        },
        releaseChannel: {
            stable: 'مستقر',
            beta: 'تجريبي',
            dev: 'تطوير',
        },
        auditEntity: {
            app_user: 'المستخدم',
            user: 'المستخدم',
            auth: 'الدخول',
            approval: 'طلب موافقة',
            approval_request: 'طلب موافقة',
            ar: 'الذمم',
            business_date: 'تاريخ العمل',
            cashier_shift: 'وردية الصندوق',
            channel: 'القنوات',
            channel_booking: 'حجز من القنوات',
            charge_code: 'رمز الرسم',
            company_account: 'حساب شركة',
            credit_note: 'إشعار دائن',
            exchange_rate: 'سعر الصرف',
            folio: 'الفوليو',
            folio_line: 'سطر الفوليو',
            group: 'المجموعة',
            group_block: 'المجموعة',
            guest: 'النزيل',
            guest_identity_document: 'وثيقة هوية',
            handover_note: 'ملاحظة تسليم',
            housekeeping: 'التدبير',
            housekeeping_task: 'مهمة تدبير',
            import: 'الاستيراد',
            invoice: 'الفاتورة',
            invoice_series: 'سلسلة الفواتير',
            license: 'الترخيص',
            maintenance_ticket: 'تذكرة صيانة',
            night_audit: 'التدقيق الليلي',
            night_audit_run: 'التدقيق الليلي',
            notification: 'إشعار',
            pii: 'بيانات شخصية',
            property: 'المنشأة',
            rate_plan: 'خطة السعر',
            rate_rule: 'قاعدة السعر',
            replay: 'حدث مستورد',
            replay_event: 'حدث مستورد',
            reservation: 'الحجز',
            reservation_room: 'غرفة الحجز',
            retention: 'الاحتفاظ بالبيانات',
            room: 'الغرفة',
            room_type: 'نوع الغرفة',
            stay: 'الإقامة',
            support: 'الدعم',
            support_grant: 'وصول الدعم',
            support_access_grant: 'وصول الدعم',
            tax: 'الضريبة',
            directory_user: 'مستخدم الدليل',
            feature_flags: 'إعدادات الميزات',
            maintenance_window: 'نافذة الصيانة',
            node: 'خادم الفندق',
            onboarding: 'التهيئة',
            onboarding_batch: 'دفعة تهيئة',
            release: 'الإصدار',
            staff: 'فريق سيروفا',
            staff_user: 'فريق سيروفا',
            tenant: 'المستأجر',
            tenant_user: 'مستخدم البوابة',
            ticket: 'تذكرة دعم',
            wave: 'موجة النشر',
        },
        auditVerb: {
            created: 'إنشاء',
            updated: 'تعديل',
            deleted: 'حذف',
            opened: 'فتح',
            closed: 'إغلاق',
            reopened: 'إعادة فتح',
            approved: 'موافقة',
            ended: 'إنهاء',
            requested: 'طلب',
            expired: 'انتهاء المهلة',
            cancelled: 'إلغاء',
            released: 'إفراج',
            posted: 'ترحيل',
            reversed: 'عكس',
            transferred: 'تحويل',
            adjusted: 'تسوية',
            applied: 'تطبيق',
            revoked: 'إلغاء',
            issued: 'إصدار',
            merged: 'دمج',
            anonymized: 'تجهيل',
            anonymize_scheduled: 'جدولة التجهيل',
            captured: 'تسجيل',
            acknowledged: 'إقرار بالاستلام',
            assigned: 'إسناد',
            distributed: 'توزيع',
            flagged: 'تعليم',
            generated: 'توليد',
            completed: 'اكتمال',
            started: 'بدء',
            override: 'تجاوز فحص',
            accessed: 'اطلاع',
            settings_changed: 'تغيير الإعدادات',
            status_changed: 'تغيير الحالة',
            checked_in: 'تسجيل الدخول',
            checked_out: 'تسجيل الخروج',
            room_moved: 'نقل غرفة',
            extended: 'تمديد',
            shortened: 'تقصير',
            auto_extended: 'تمديد تلقائي',
            check_in_undone: 'تراجع عن الدخول',
            carried: 'ترحيل الرصيد',
            rolled: 'تقديم التاريخ',
            reclaimed: 'استرداد التفويض',
            dismissed: 'إغلاق',
            modified: 'تعديل',
            unassigned: 'إلغاء التعيين',
            no_show: 'عدم حضور',
            confirmed: 'تأكيد',
            hold: 'حجز مؤقت',
            rejected: 'رفض',
            node_rejected: 'رفض الفندق',
            done: 'إنجاز',
            in_progress: 'بدء العمل',
            inspected: 'فحص',
            provisioned: 'تجهيز',
            activated: 'تفعيل',
            retired: 'إيقاف',
            batch_imported: 'استيراد دفعة',
            published: 'نشر',
            withdrawn: 'سحب',
            rollout_set: 'ضبط نسبة النشر',
            auto_paused: 'إيقاف تلقائي',
            snapshot: 'لقطة قراءة',
            disabled_from_cloud: 'تعطيل من السحابة',
            lines_transferred: 'نقل سطور',
            window_opened: 'فتح نافذة',
            discount_posted: 'ترحيل خصم',
            transferred_to_ar: 'تحويل إلى حساب شركة',
            master_folio_opened: 'فتح الحساب الرئيسي',
            rooming_list: 'قائمة الأسماء',
            discrepancy_noted: 'تسجيل تباين',
            discrepancy_resolved: 'حل التباين',
            identity_documents_wiped: 'حذف الوثائق',
            set: 'ضبط',
            status: 'تغيير الحالة',
            guests: 'نزلاء',
            rooms: 'غرف',
            channel_settings: 'إعدادات القنوات',
        },
        auditAction: {
            'auth.login': 'تسجيل الدخول',
            'auth.logout': 'تسجيل الخروج',
            'auth.mfa_enabled': 'تفعيل التحقق بخطوتين',
            'auth.mfa_disabled': 'تعطيل التحقق بخطوتين',
            'auth.mfa_failed': 'رمز تحقق خاطئ',
            'auth.mfa_recovery_used': 'استخدام رمز استرداد',
            'auth.mfa_throttled': 'إيقاف مؤقت لمحاولات التحقق',
            'auth.password_changed': 'تغيير كلمة المرور',
            'auth.pin_set': 'ضبط الرمز السري',
            'auth.reauth': 'إعادة المصادقة',
            'auth.reauth_failed': 'فشل إعادة المصادقة',
            'pii.accessed': 'اطلاع على بيانات شخصية',
            'import.guests': 'استيراد نزلاء',
            'import.rooms': 'استيراد غرف',
            'business_date.rolled': 'تقديم تاريخ العمل',
        },
        lineType: {
            charge: 'رسم',
            service_charge: 'رسم خدمة',
            tax: 'ضريبة',
            discount: 'خصم',
            payment: 'دفعة',
            change: 'باقي',
            deposit: 'وديعة',
            refund: 'استرداد',
            rounding: 'تقريب',
            fx_difference: 'فرق صرف',
        },
        revenueGroup: {
            room: 'الغرف',
            f_and_b: 'الطعام والشراب',
            laundry: 'الغسيل',
            minibar: 'الميني بار',
            phone: 'الهاتف',
            misc: 'متفرقات',
            package: 'الباقات',
            fee: 'رسوم',
            system: 'النظام',
        },
        paymentMethod: {
            cash: 'نقداً',
            card: 'بطاقة',
            bank_transfer: 'تحويل بنكي',
            other: 'أخرى',
            city_ledger: 'حساب شركة',
        },
        invoiceKind: { final: 'فاتورة نهائية', proforma: 'فاتورة مبدئية', credit_note: 'إشعار دائن' },
        shiftStatus: { open: 'مفتوحة', closed: 'مغلقة' },
        noteKind: {
            guest_request: 'طلب النزيل',
            internal: 'داخلية',
            housekeeping: 'التدبير',
            billing: 'الفوترة',
        },
        taxKind: {
            percentage: 'نسبة مئوية',
            fixed_per_night: 'مبلغ ثابت لكل ليلة',
            fixed_per_stay: 'مبلغ ثابت لكل إقامة',
            service_charge: 'رسم خدمة',
        },
        lineSource: {
            manual: 'يدوي',
            night_audit: 'التدقيق الليلي',
            system: 'النظام',
            pos: 'نقطة البيع',
            transfer: 'تحويل',
        },
    },
    app: {
        name: 'سيروفا',
        tagline: 'نظام تشغيل الفندق',
    },
    common: {
        viewAll: 'عرض الكل',
        all: 'الكل',
        previous: 'السابق',
        next: 'التالي',
        type: 'النوع',
        resultsCount: '{{n}} نتيجة',
        saved: 'تم الحفظ',
        open: 'فتح',
        save: 'حفظ',
        cancel: 'إلغاء',
        close: 'إغلاق',
        confirm: 'تأكيد',
        back: 'رجوع',
        search: 'بحث',
        loading: 'جارٍ التحميل…',
        yes: 'نعم',
        no: 'لا',
        required: 'هذا الحقل مطلوب',
        none: 'لا شيء',
        print: 'طباعة',
        actions: 'إجراءات',
        reason: 'السبب',
        notes: 'ملاحظات',
        adults: 'بالغون',
        children: 'أطفال',
        nights: 'الليالي',
        total: 'الإجمالي',
        date: 'التاريخ',
        from: 'من',
        to: 'إلى',
        today: 'اليوم',
        new: 'جديد',
        edit: 'تعديل',
        details: 'التفاصيل',
        noResults: 'لا نتائج',
        retry: 'إعادة المحاولة',
        optional: 'اختياري',
    },
    nav: {
        frontDesk: 'الاستقبال',
        dashboard: 'لوحة اليوم',
        arrivals: 'الوصول',
        departures: 'المغادرة',
        inHouse: 'المقيمون',
        walkIn: 'نزيل بدون حجز',
        reservations: 'الحجوزات',
        newReservation: 'حجز جديد',
        tapeChart: 'شبكة الغرف',
        guests: 'النزلاء',
        cashier: 'الصندوق',
        housekeeping: 'التدبير الفندقي',
        reports: 'التقارير',
        nightAudit: 'التدقيق الليلي',
        admin: 'الإدارة',
        comingSoon: 'قريباً',
        theme: 'الوضع الداكن',
        groupFinance: 'المالية',
        groupOperations: 'العمليات',
        groupReports: 'التقارير والتحليل',
        groupAdmin: 'الإدارة',
        collapse: 'طيّ القائمة',
        expand: 'توسيع القائمة',
        language: 'English',
        themeLight: 'الوضع الفاتح',
        search: 'بحث',
    },
    auth: {
        login: 'تسجيل الدخول',
        logout: 'تسجيل الخروج',
        username: 'اسم المستخدم',
        password: 'كلمة المرور',
        pin: 'الرمز السري',
        enterPin: 'أدخل الرمز السري للمتابعة',
        invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
        accountLocked: 'الحساب مقفل مؤقتاً بسبب محاولات فاشلة متكررة. حاول بعد {{wait}}.',
        mustChangePassword: 'يجب تغيير كلمة المرور قبل المتابعة',
        sessionExpired: 'انتهت الجلسة. سجّل الدخول مجدداً.',
        lockScreen: 'قفل الشاشة',
        locked: 'الشاشة مقفلة',
        unlock: 'فتح',
        invalidPin: 'الرمز السري غير صحيح',
        pinNotSet: 'لم يُضبط رمز سري لهذا المستخدم',
        pinSetupTitle: 'اضبط رمزك السري',
        pinSetupHint: 'العمليات المالية تتطلب رمزاً سرياً من 4 إلى 6 أرقام. أدخل كلمة مرورك واختر رمزاً؛ ستستخدمه من الآن بدل كلمة المرور لتأكيد هذه العمليات.',
        newPin: 'الرمز السري الجديد (4–6 أرقام)',
        pinFormat: 'الرمز السري من 4 إلى 6 أرقام',
    },
    status: {
        businessDate: 'تاريخ العمل',
        shift: 'الوردية',
        shiftOpen: 'وردية مفتوحة',
        shiftClosed: 'لا وردية مفتوحة',
        shiftOpenSince: 'وردية مفتوحة منذ {{time}}',
        sync: 'المزامنة',
        syncOk: 'متزامن',
        syncDelayed: 'مزامنة متأخرة منذ {{age}}',
        syncOffline: 'بلا اتصال بالسحابة منذ {{age}}',
        power: 'الطاقة',
        onBattery: 'يعمل على البطارية (المتبقي: {{minutes}} د)',
        nodeUnreachable: 'تعذّر الوصول إلى خادم الفندق. تحقّق من الشبكة ثم أعد المحاولة.',
        nodeRecovering: 'الخادم يستعيد عمله بعد انقطاع الكهرباء. يرجى الانتظار…',
    },
    health: {
        msg: {
            backupCompleted: 'اكتمل النسخ الاحتياطي',
            backupFailed: 'فشل النسخ الاحتياطي',
            drillPassed: 'نجح تمرين الاستعادة',
            drillFailed: 'فشل تمرين الاستعادة',
            resumedUnclean: 'استؤنف العمل بعد إيقاف غير نظيف',
            nodeActivated: 'فُعّل خادم الفندق مع السحابة',
            licenseApplied: 'طُبّق الترخيص القادم من السحابة',
            licenseRevoked: 'ألغت السحابة الترخيص',
            channelBooking: 'حجز من القنوات ← {{ref}}',
            updated: 'حُدّث النظام إلى {{v}}',
            agentStopping: 'توقّف وكيل الخادم',
            updateRolledBack: 'تراجع التحديث إلى {{v}} وعاد النظام للإصدار السابق',
            updateFailed: 'فشل التحديث إلى {{v}} قبل التبديل',
            manifestRejected: 'رُفض بيان التحديث',
            supportSnapshotFailed: 'تعذّر إرسال لقطة الدعم',
            supportRequest: 'فريق سيروفا يطلب وصولاً ({{scope}}) — تذكرة {{ticket}}',
            commandRejected: 'رُفض أمر من السحابة ({{cmd}})',
            clockBehind: 'ساعة الخادم متأخرة عن آخر حدث مسجّل',
            diskCritical: 'القرص ممتلئ تقريباً — حرّر مساحة فوراً',
            replayImport: 'استيراد أحداث الاستعادة',
            cloudKeysMissing: 'مفاتيح التحقق من السحابة غير مضبوطة',
            agentVersion: 'الوكيل {{v}}',
            megabytes: '{{n}} ميغابايت',
        },
        title: 'صحة النظام',
        navLabel: 'صحة النظام',
        agentStale: 'وكيل العقدة لا يستجيب منذ {{age}}. تحقّق من خدمة وكيل سيروفا على الخادم.',
        agentNever: 'لم يرسل وكيل العقدة أي قراءة بعد.',
        updatedAt: 'آخر قراءة',
        cards: {
            postgres: 'قاعدة البيانات',
            api: 'خادم التطبيق',
            disk: 'قرص البيانات',
            backupDisk: 'قرص النسخ الخارجي',
            backup: 'آخر نسخة احتياطية',
            drill: 'آخر تمرين استعادة',
            outbox: 'أحداث بانتظار المزامنة',
            sync: 'آخر اتصال بالسحابة',
            power: 'الطاقة',
            clock: 'الساعة',
            unclean: 'انقطاعات غير نظيفة (7 أيام)',
            boot: 'زمن الإقلاع إلى الجاهزية',
            version: 'الإصدار',
        },
        values: {
            up: 'تعمل',
            down: 'متوقفة',
            recovering: 'قيد التعافي',
            ready: 'جاهز',
            notReady: 'غير جاهز',
            free: 'متاح \u2068{{pct}}%\u2069 (\u2068{{gb}}\u2069 غيغابايت)',
            missing: 'غير موصول',
            readOnly: 'غير قابل للكتابة',
            never: 'لم تُنفَّذ بعد',
            ok: 'ناجح',
            failed: 'فشل',
            notConfigured: 'غير مضبوط',
            mains: 'التيار الكهربائي',
            battery: 'على البطارية (\u2068{{pct}}%\u2069)',
            noBattery: 'لم يُكتشف مزوّد طاقة احتياطي',
            clockOk: 'سليمة',
            clockAnomaly: 'الساعة متأخرة عن آخر حدث مسجّل!',
            seconds: '{{s}} ثانية',
            events: '{{n}}',
            schema: 'مخطط {{v}}',
        },
        actions: {
            backupNow: 'نسخ احتياطي الآن',
            drillNow: 'تمرين استعادة الآن',
            started: 'بدأ التنفيذ. تظهر النتيجة في السجل خلال دقائق.',
        },
        upsHint: 'يُوصى بتركيب UPS لهذا الحاسوب: انقطاع الكهرباء يعني إعادة تشغيل غير نظيفة. النظام يحمي البيانات الملتزمة لكن UPS يحمي العمل الجاري.',
        thresholds: 'عتبات التنبيه: القرص < 20% تحذير، < 10% حرج؛ نسخة احتياطية > 8 ساعات؛ قرص النسخ غير موصول > 24 ساعة حرج؛ تمرين استعادة > 8 أيام.',
        log: 'سجل آخر العمليات',
        backups: 'النسخ الاحتياطية',
        replay: {
            title: 'مطابقة الاستعادة من السحابة',
            hint: 'الأحداث التي استُوردت من السحابة بعد استعادة نسخة احتياطية: «مفقود» = لم تُسجَّل محلياً وتحتاج إعادة إدخال يدوي ثم إغلاقاً بملاحظة.',
            missing: 'مفقود',
            present: 'موجود',
            dismissed: 'مغلق',
            lastImport: 'آخر استيراد',
            none: 'لا استيراد بعد. على الخادم المستعاد شغّل أمر الاستيراد: syrova-agent replay-import --cloud',
            dismiss: 'إغلاق',
            dismissNote: 'ما الذي أُعيد إدخاله أو سبب التخطي؟',
            byType: 'حسب النوع',
            payload: 'الحمولة',
        },
        cols: {
            when: 'الوقت',
            kind: 'النوع',
            level: 'المستوى',
            message: 'الرسالة',
            size: 'الحجم',
            status: 'الحالة',
            verified: 'تمرين الاستعادة',
            location: 'الملف',
        },
        kinds: {
            cloud: 'السحابة',
            replay: 'استيراد أحداث',
            sync: 'المزامنة',
            support: 'الدعم',
            update: 'التحديث',
            release: 'الإصدار',
            boot: 'إقلاع',
            stop: 'إيقاف',
            unclean_shutdown: 'انقطاع غير نظيف',
            self_check: 'فحص ذاتي',
            backup: 'نسخ احتياطي',
            restore_drill: 'تمرين استعادة',
            clock_anomaly: 'انحراف الساعة',
            power: 'الطاقة',
            disk: 'القرص',
        },
        alerts: {
            AGENT_DOWN: 'وكيل العقدة لا يستجيب',
            PG_DOWN: 'قاعدة البيانات متوقفة',
            PG_RECOVERING: 'قاعدة البيانات قيد التعافي',
            API_DOWN: 'خادم التطبيق غير جاهز',
            DISK_LOW: 'مساحة القرص منخفضة ({{value}}%)',
            DISK_CRITICAL: 'مساحة القرص حرجة ({{value}}%) — حرّر مساحة فوراً',
            BACKUP_NOT_CONFIGURED: 'النسخ الاحتياطي غير مضبوط',
            BACKUP_TARGET_MISSING: 'قرص النسخ الاحتياطي غير موصول منذ {{age}}',
            BACKUP_TARGET_MISSING_NEW: 'قرص النسخ الاحتياطي غير موصول',
            BACKUP_DISK_FULL: 'قرص النسخ الاحتياطي شبه ممتلئ',
            BACKUP_STALE: 'لا نسخة احتياطية ناجحة منذ {{age}}',
            BACKUP_NEVER: 'لم تُنجز أي نسخة احتياطية بعد',
            BACKUP_FAILED: 'فشلت آخر نسخة احتياطية',
            DRILL_FAILED: 'فشل تمرين الاستعادة — النسخ الاحتياطية قد لا تكون صالحة',
            DRILL_STALE: 'لم يُنفَّذ تمرين استعادة منذ أكثر من أسبوع',
            OUTBOX_BACKLOG: 'تراكم أحداث المزامنة ({{value}})',
            CLOCK_ANOMALY: 'ساعة الجهاز غير صحيحة — اضبطها قبل المتابعة',
            UNCLEAN_SHUTDOWNS: 'انقطاعات كهرباء متكررة ({{value}} خلال 7 أيام) — افحص مزوّد الطاقة الاحتياطي',
            POWER_BATTERY: 'يعمل على البطارية',
            POWER_LOW: 'البطارية منخفضة ({{value}}%)',
            POWER_CRITICAL: 'البطارية حرجة ({{value}}%) — احفظ عملك؛ سيُغلق النظام',
            UPS_RECOMMENDED: 'لا مزوّد طاقة احتياطي مكتشف (موصى به)',
        },
        bannerLink: 'التفاصيل',
    },
    boot: {
        title: 'خادم الفندق يقلع…',
        hint: 'انتظر دقيقتين. هذه الصفحة تتحدث تلقائياً كل 5 ثوانٍ.',
        unreachable: 'تعذّر الوصول إلى خادم الفندق. تحقّق من كهرباء الجهاز والشبكة (الـ switch) ثم أعد المحاولة. البطاقة المطبوعة تحمل عنوان IP البديل.',
        lastKnown: 'آخر حالة معروفة: تاريخ العمل {{date}}، آخر عملية {{time}}',
        checks: {
            postgres: 'قاعدة البيانات',
            api: 'خادم التطبيق',
            disk: 'القرص',
            backup: 'النسخ الاحتياطي',
            power: 'الطاقة',
            clock: 'الساعة',
        },
        pending: 'قيد الفحص',
    },
    resume: {
        title: 'عاد النظام بعد انقطاع في {{time}}.',
        titleClean: 'أُعيد تشغيل النظام في {{time}}.',
        lastSaved: 'لم تُفقد بيانات ملتزمة: آخر عملية محفوظة {{time}} ({{action}}).',
        noSaved: 'لا عمليات مسجّلة قبل الانقطاع.',
        formsLost: 'النماذج التي كانت قيد الكتابة في المتصفح ولم تُرسل لم تُحفظ — تحقّق مما كنت تفعله.',
        openShift: 'وردية {{user}} مفتوحة منذ {{time}}',
        audit: 'التدقيق الليلي لتاريخ {{date}} غير مكتمل ({{status}})',
        outbox: 'أحداث بانتظار المزامنة: {{n}}',
        dismiss: 'فهمت',
    },
    license: {
        title: 'الترخيص',
        stage: 'الحالة',
        expiresAt: 'ينتهي في',
        perpetual: 'دائم — بلا تاريخ انتهاء',
        daysLeft: 'متبقٍ {{days}}',
        daysOver: 'منتهٍ منذ {{days}}',
        plan: 'الخطة',
        roomCap: 'حد الغرف: {{n}}',
        node: 'بصمة الجهاز',
        noIdentity: 'لم يُنشئ وكيل العقدة هوية الجهاز بعد',
        activated: 'مفعّل مع السحابة منذ {{at}}',
        notActivated: 'غير مفعّل مع السحابة (يعمل محلياً)',
        ladderHint: 'لا يُمنع أبداً تسجيل المغادرة ولا تسجيل الدفعات ولا تصدير البيانات مهما كانت حالة الترخيص.',
        applyTitle: 'تطبيق ترخيص بلا إنترنت',
        applyHint: 'الصق محتوى ملف الترخيص الموقّع الذي أرسلته سيروفا. يُتحقق من التوقيع وبصمة هذا الجهاز قبل التطبيق.',
        pasteLabel: 'ملف الترخيص',
        applyButton: 'تطبيق الترخيص',
        applied: 'طُبّق الترخيص',
        alreadyCurrent: 'هذا الترخيص مطبّق مسبقاً',
        invalidJson: 'محتوى الملف غير صالح',
        stages: {
            none: 'غير مفعّل',
            ok: 'ساري',
            pre_expiry: 'يقترب من الانتهاء',
            warning: 'منتهٍ — فترة تنبيه',
            degraded: 'منتهٍ — إعدادات مجمّدة',
            floor: 'منتهٍ — قراءة فقط',
            not_yet_valid: 'لم يبدأ سريانه بعد',
        },
        banner: {
            none: 'هذا الخادم غير مرتبط بسيروفا بعد: فعّله برمز التفعيل، أو طبّق ملف الترخيص من شاشة الترخيص.',
            pending: 'الخادم مفعّل، والترخيص في الطريق من سحابة سيروفا: يصل خلال دقائق ما دام الإنترنت متاحاً.',
            preExpiry: 'ينتهي الترخيص خلال {{days}}. تواصل مع سيروفا للتجديد.',
            warning: 'انتهى الترخيص منذ {{days}}. كل شيء يعمل الآن؛ جدّد قبل تقييد الإعدادات.',
            degraded: 'الترخيص منتهٍ: شاشات الإعدادات للقراءة فقط. تسجيل الدخول/المغادرة والدفعات والحجوزات تعمل.',
            floor: 'الترخيص منتهٍ أو مُبطل: قراءة فقط باستثناء تسجيل المغادرة والدفعات والتصدير. تواصل مع سيروفا.',
            notYetValid: 'الترخيص المطبّق لم يبدأ سريانه بعد.',
        },
    },
    cloud: {
        adminName: 'سيروفا — لوحة التشغيل',
        adminSub: 'لوحة التشغيل',
        portalSub: 'بوابة المالك',
        portalName: 'سيروفا — بوابة المالك',
        email: 'البريد الإلكتروني',
        logout: 'تسجيل الخروج',
        nav: {
            tenants: 'المستأجرون',
            fleet: 'الأسطول',
            grants: 'طلبات الدعم',
            properties: 'منشآتي',
            reports: 'التقارير',
            audit: 'السجل',
        },
        tenants: {
            title: 'المستأجرون',
            new: 'مستأجر جديد',
            code: 'الرمز',
            nameAr: 'الاسم',
            nameEn: 'الاسم بالإنجليزية',
            contact: 'بريد التواصل',
            properties: 'المنشآت',
            created: 'أُنشئ المستأجر',
        },
        tenant: {
            newProperty: 'منشأة جديدة',
            roomCap: 'حد الغرف',
            timezone: 'المنطقة الزمنية',
            currency: 'العملة الأساسية',
            portalUsers: 'مستخدمو البوابة',
            newPortalUser: 'مستخدم بوابة جديد',
            directory: 'دليل الموظفين',
            newDirectoryUser: 'موظف جديد',
            username: 'اسم المستخدم',
            displayName: 'الاسم المعروض',
            password: 'كلمة المرور',
            role: 'الدور',
            assignTo: 'المنشأة',
            roleCode: 'رمز الدور على العقدة',
            audit: 'سجل الإجراءات',
        },
        property: {
            node: 'العقدة',
            noNode: 'لا عقدة بعد',
            provision: 'تجهيز عقدة (رمز تفعيل)',
            activationCode: 'رمز التفعيل (يُعرض مرة واحدة)',
            activationHint: 'على خادم الفندق: node-agent activate --url {{url}} --code {{code}} — صالح حتى {{expires}}',
            retire: 'إنهاء العقدة',
            retireReason: 'سبب الإنهاء',
            status: { provisioned: 'بانتظار التفعيل', active: 'مفعّلة', retired: 'منتهية' },
            lastSeen: 'آخر اتصال',
            never: 'لم تتصل بعد',
            license: 'الترخيص',
            noLicense: 'لا ترخيص',
            issue: 'إصدار ترخيص',
            planCode: 'رمز الخطة',
            expiresAt: 'تاريخ الانتهاء',
            perpetualHint: 'اتركه فارغاً لترخيص دائم (البرنامج مجاني)',
            modules: 'الوحدات (مفصولة بفاصلة)',
            revoke: 'إبطال',
            revokeReason: 'سبب الإبطال',
            issued: 'أُصدر الترخيص وأُرسل أمر للعقدة',
            flags: 'إعدادات الميزات',
            saveFlags: 'حفظ الأعلام',
            window: 'نافذة الصيانة',
            dayOfWeek: 'اليوم',
            startTime: 'البداية',
            duration: 'المدة (دقائق)',
            saveWindow: 'حفظ النافذة',
            commands: 'آخر الأوامر',
            backups: 'النسخ المبلّغة',
            days: {
                d0: 'الأحد',
                d1: 'الاثنين',
                d2: 'الثلاثاء',
                d3: 'الأربعاء',
                d4: 'الخميس',
                d5: 'الجمعة',
                d6: 'السبت',
            },
        },
        fleet: {
            title: 'الأسطول',
            tenant: 'المستأجر',
            property: 'المنشأة',
            version: 'الإصدار',
            schema: 'المخطط',
            seen: 'آخر اتصال',
            minutesAgo: 'قبل {{n}} د',
            stage: 'الترخيص',
            backup: 'آخر نسخة',
            alerts: 'تنبيهات',
            pending: 'أوامر معلّقة',
        },
        grants: {
            snapshots: 'لقطات الجلسة',
            lastActivity: 'آخر نشاط',
            noSnapshots: 'لا لقطات بعد',
            view: 'عرض',
            close: 'إغلاق',
            anchors: 'مراسي التدقيق',
            title: 'طلبات وصول الدعم',
            request: 'طلب وصول',
            property: 'المنشأة',
            scope: 'النطاق',
            reason: 'السبب',
            ticket: 'رقم التذكرة',
            duration: 'المدة (دقائق)',
            status: 'الحالة',
            requested: 'طلب الوصول أُرسل إلى المالك',
            approve: 'موافقة',
            reject: 'رفض',
            decided: 'سُجّل القرار',
            scopes: { readonly_ops: 'قراءة فقط', diagnostics: 'تشخيص', full: 'كامل' },
            statuses: {
                requested: 'بانتظار الموافقة',
                approved: 'موافق عليه',
                active: 'نشط',
                expired: 'منتهٍ',
                revoked: 'مُلغى',
                rejected: 'مرفوض',
            },
            portalHint: 'طلبات سيروفا للوصول إلى عقدة فندقك. لا وصول بدون موافقتك؛ كل إجراء يُسجَّل.',
        },
        mfa: {
            code: 'رمز المصادقة (أو رمز استعادة)',
            required: 'أدخل رمز تطبيق المصادقة',
            enrolTitle: 'فعّل التحقق بخطوتين للمتابعة',
            enrolHint: 'إلزامي لحسابات سيروفا ومديري المستأجرين، ويستغرق دقيقة واحدة.',
            secret: 'المفتاح',
            stepApp: 'ثبّت تطبيق مصادقة على هاتفك، مثل Google Authenticator أو Microsoft Authenticator.',
            stepScan: 'افتح التطبيق وامسح هذا الرمز.',
            qrLabel: 'رمز QR لإضافة الحساب إلى تطبيق المصادقة',
            manual: 'لا يمكنك المسح؟ أدخل المفتاح يدوياً',
            copy: 'نسخ',
            copied: 'تم النسخ',
            stepCode: 'أدخل الرمز المكوّن من 6 أرقام الظاهر في التطبيق.',
            confirm: 'تأكيد',
            recovery: 'رموز الاستعادة (تُعرض مرة واحدة)',
            recoveryHint: 'احفظها في مكان آمن خارج هذا الجهاز. كل رمز يُستخدم مرة واحدة لتسجيل الدخول إذا فقدت هاتفك.',
            copyAll: 'نسخ الرموز',
            continue: 'متابعة',
        },
        tickets: {
            title: 'التذاكر',
            nav: 'التذاكر',
            portalNav: 'الدعم',
            new: 'تذكرة جديدة',
            subject: 'الموضوع',
            body: 'التفاصيل',
            severity: 'الخطورة',
            status: 'الحالة',
            property: 'المنشأة',
            updated: 'آخر تحديث',
            assign: 'تعيين لي',
            comment: 'رد',
            send: 'إرسال',
            showAll: 'عرض المغلقة أيضاً',
            created: 'فُتحت التذكرة',
            empty: 'لا تذاكر مفتوحة',
            severities: { low: 'منخفضة', normal: 'عادية', high: 'عالية', critical: 'حرجة' },
            statuses: {
                open: 'مفتوحة',
                in_progress: 'قيد المعالجة',
                waiting_hotel: 'بانتظار الفندق',
                resolved: 'تم الحل',
                closed: 'مغلقة',
            },
            setStatus: 'تغيير الحالة',
            portalHint: 'افتح تذكرة لأي مشكلة؛ فريق سيروفا يرد هنا وفي رقم الدعم. لا بيانات نزلاء في التذاكر.',
        },
        rollout: {
            nav: 'النشر الوطني',
            title: 'النشر الوطني — الموجات والمؤشرات',
            waves: 'الموجات',
            wavesHint: 'إيقاف الموجة يمنع تفعيل عقد جديدة فيها فقط؛ المنشآت المركّبة تستمر (مفتاح إيقاف مستقل لكل موجة).',
            wave: 'الموجة',
            properties: 'مركّبة / مسجّلة',
            propertiesCount: 'المنشآت',
            installs: 'التركيبات',
            paused: 'موقوفة',
            running: 'جارية',
            pause: 'إيقاف التركيبات',
            resume: 'استئناف',
            pauseReason: 'سبب الإيقاف',
            weekly: 'التقرير الأسبوعي للجنة التوجيه',
            weeklyLine: 'رُكّبت {{installed}} هذا الأسبوع (الإجمالي {{total}}) · متوقفة > 24h: {{stalled}} · تنبيهات حرجة: {{critical}} · تذاكر: فُتحت {{opened}}، حُلّت {{resolved}}، مفتوحة {{open}} · حجوزات {{reservations}}، تسجيل دخول {{checkIns}}، تدقيق ليلي {{audits}} · تحديثات {{updates}} (تراجع {{rolledBack}})',
            kpi: {
                coverage: 'التغطية (مركّبة/مسجّلة)',
                active60d: 'نشطة خلال 7 أيام',
                stalled: 'متوقفة > 24 ساعة',
                ticketP50: 'حل التذكرة p50 (ساعات)',
                doubleBookings: 'حجوزات مزدوجة',
            },
            ministry: 'لوحة الوزارة (مجمّعة حسب المحافظة)',
            ministryHint: 'أرقام مجمّعة بلا أسماء منشآت أو نزلاء؛ الإشغال يُحجب عندما تقل المنشآت المبلّغة عن 5 (لحماية الخصوصية).',
            csv: 'تنزيل ملف جدول',
            governorate: 'المحافظة',
            rooms: 'الغرف',
            installed: 'مركّبة',
            active7d: 'نشطة (7 أيام)',
            occupancy: 'الإشغال',
            suppressed: 'محجوب (<5)',
            totals: 'الإجمالي: {{properties}} منشأة · {{installed}} مركّبة · {{active}} نشطة · إشغال {{occupancy}}',
        },
        onboarding: {
            title: 'تهيئة المنشآت دفعةً',
            nav: 'التهيئة',
            hint: 'الصق محتوى ملف الجدول من سجل المنشآت، بالأعمدة التالية بالترتيب: tenant_code,tenant_name_ar,property_code,property_name_ar,room_cap[,governorate][,category][,wave][,owner_email][,contact_email]. لكل صف تُنشأ المنشأة وعقدة برمز تفعيل لمرة واحدة، ومالك بوابة بكلمة مؤقتة إن أُعطي بريده. اطبع الأوراق فوراً: الرموز لا تُعرض مرة أخرى.',
            run: 'تهيئة',
            result: 'منشآت أُنشئت: {{props}} · مستأجرون جدد: {{tenants}} · أخطاء: {{errors}}',
            sheets: 'أوراق التفعيل',
            print: 'طباعة الأوراق',
            sheetTitle: 'ورقة تفعيل سيروفا',
            code: 'رمز التفعيل',
            expires: 'صالح حتى',
            owner: 'حساب البوابة',
            tempPassword: 'كلمة مرور مؤقتة (تُغيَّر عند أول دخول)',
            steps: 'الخطوات: 1) شغّل المثبّت على حاسوب الفندق 2) أدخل رمز التفعيل عند الطلب 3) افتح https://<اسم-الحاسوب>.local وأكمل معالج الإعداد.',
            errors: 'الأخطاء',
        },
        channels: {
            guestPending: 'بانتظار بيانات الضيف',
            nav: 'القنوات',
            title: 'القنوات والحجوزات الإلكترونية',
            partners: 'الشركاء',
            newChannel: 'قناة جديدة',
            code: 'الرمز',
            name: 'الاسم',
            rateLimit: 'حد الطلبات/دقيقة',
            bookings: 'حجوزات',
            status: 'الحالة',
            suspend: 'إيقاف',
            activate: 'تفعيل',
            keyOnce: 'مفتاح الربط — يُعرض مرة واحدة فقط، انسخه الآن:',
            propertySlug: 'رابط صفحة الحجز',
            saveSlug: 'حفظ',
            bookingsTitle: 'الحجوزات الإلكترونية',
            unsettled: 'غير مستقرة (لم تصل للفندق)',
            all: 'الكل',
            mode: { instant: 'فوري', requested: 'طلب' },
            statuses: {
                held: 'محجوز مؤقتاً',
                confirmed: 'مؤكد',
                requested: 'طلب',
                accepted: 'مقبول',
                rejected: 'مرفوض',
                cancelled: 'ملغى',
                expired: 'منتهٍ',
            },
            hotelRef: 'رقم الفندق',
            applied: 'وصل الفندق',
            notApplied: 'لم يصل بعد',
            redelivered: 'أُعيد إرساله {{n}}',
            decideAccept: 'قبول',
            decideReject: 'رفض',
            cancel: 'إلغاء',
            pendingNode: 'أُرسل القرار إلى الفندق؛ يُغلق عند وصول حدثه',
        },
        portal: {
            properties: 'منشآتي',
            connected: 'متصل',
            stale: 'منقطع منذ {{n}} د',
            offline: 'لا اتصال',
            businessDate: 'تاريخ العمل',
            occupancy: 'الإشغال',
            inHouse: 'نزلاء مقيمون',
            arrivals: 'وصول اليوم',
            departures: 'مغادرة اليوم',
            backup: 'آخر نسخة احتياطية',
            drillOk: 'تمرين الاستعادة ناجح',
            drillFailed: 'تمرين الاستعادة فاشل',
            reports: 'ملخص يومي من العقد (مجهّل — لا أسماء نزلاء)',
            noData: 'لا بيانات بعد؛ تظهر بعد أول اتصال للعقدة.',
            summary: 'ملخص المنشآت (آخر {{days}} يوماً)',
            roomCap: 'الغرف',
            avgOccupancy: 'متوسط الإشغال',
            nightAudits: 'تدقيقات ليلية / أيام',
            shareWhatsapp: 'مشاركة الملخص عبر واتساب',
            totals: 'الإجمالي: منشآت · غرف · إشغال · مقيمون · وصول · حجوزات · فواتير · تدقيقات',
        },
        releases: {
            title: 'الإصدارات',
            publish: 'نشر بيان إصدار موقّع',
            publishHint: 'الصق ملف بيان الإصدار (manifest.json) بعد توقيعه بمفتاحين. السجل يتحقق من التوقيعات.',
            published: 'نُشر الإصدار',
            version: 'الإصدار',
            channel: 'القناة',
            rollout: 'نسبة الطرح',
            attempted: 'محاولات',
            done: 'نجح',
            failed: 'فشل',
            paused: 'موقوف آلياً',
            withdrawn: 'مسحوب',
            setRollout: 'ضبط النسبة',
            withdraw: 'سحب (إيقاف طارئ)',
            withdrawReason: 'سبب السحب',
            fleetVersions: 'توزيع الإصدارات في الأسطول',
            sync: 'المزامنة',
        },
        stages: {
            none: 'لا ترخيص',
            ok: 'ساري',
            pre_expiry: 'يقترب من الانتهاء',
            warning: 'منتهٍ (تنبيه)',
            degraded: 'متدهور',
            floor: 'قراءة فقط',
            not_yet_valid: 'لم يبدأ',
        },
    },
    security: {
        title: 'الأمان والخصوصية',
        navLabel: 'الأمان',
        mfa: {
            title: 'التحقق بخطوتين (تطبيق مصادقة)',
            hint: 'رمز من تطبيق مصادقة (مثل Aegis أو Google Authenticator) يعمل بلا إنترنت. موصى به للمدراء.',
            enabled: 'مفعّل',
            disabled: 'غير مفعّل',
            enable: 'تفعيل',
            disable: 'إلغاء التفعيل',
            secret: 'المفتاح (للإدخال اليدوي)',
            uriHint: 'امسح الرابط أو أدخل المفتاح يدوياً في التطبيق، ثم أدخل الرمز الظاهر للتأكيد.',
            code: 'رمز التحقق (6 أرقام)',
            confirm: 'تأكيد التفعيل',
            recoveryTitle: 'رموز الاستعادة — اطبعها واحفظها الآن',
            recoveryHint: 'كل رمز يُستخدم مرة واحدة إن فقدت هاتفك. لن تُعرض مرة أخرى.',
            done: 'تم تفعيل التحقق بخطوتين',
            disabledToast: 'أُلغي التحقق بخطوتين',
            passwordToDisable: 'أدخل كلمة المرور لإلغاء التفعيل',
            loginTitle: 'الخطوة الثانية',
            loginHint: 'أدخل الرمز من تطبيق المصادقة أو أحد رموز الاستعادة.',
            invalid: 'الرمز غير مقبول',
            expired: 'انتهت مهلة الخطوة الثانية. سجّل الدخول مجدداً.',
            enrolRequired: 'حسابك يتطلب تفعيل التحقق بخطوتين قبل المتابعة.',
        },
        support: {
            title: 'وصول الدعم الفني',
            hint: 'طلبات سيروفا للوصول إلى هذا الخادم. لا وصول بدون موافقتك بالرمز السري؛ القراءة فقط عبر قناة خارجة من الخادم، وكل عملية تُسجَّل.',
            none: 'لا طلبات',
            requestedBy: 'الطالب',
            scope: 'النطاق',
            reason: 'السبب',
            status: 'الحالة',
            window: 'النافذة',
            activity: 'نشاط الجلسة',
            activityCount: '{{n}} لقطة',
            approve: 'موافقة (بالرمز السري)',
            reject: 'رفض',
            end: 'إنهاء الآن',
            approved: 'تمت الموافقة؛ ستُرسل لقطات القراءة فقط أثناء النافذة',
            rejected: 'رُفض الطلب',
            ended: 'أُنهيت الجلسة',
            scopes: { readonly_ops: 'قراءة فقط', diagnostics: 'تشخيص', full: 'كامل' },
            statuses: {
                requested: 'بانتظار الموافقة',
                approved: 'موافق عليه',
                active: 'نشط',
                expired: 'منتهٍ',
                revoked: 'مُنهى',
                rejected: 'مرفوض',
            },
        },
        retention: {
            title: 'الاحتفاظ بالبيانات والتجهيل',
            hint: 'هذه القيم الافتراضية تحتاج مراجعة قانونية محلية. الوظيفة تعمل يومياً على الخادم بلا إنترنت.',
            identityDocumentMonths: 'حذف وثائق الهوية بعد (أشهر من آخر مغادرة)',
            guestProfileMonths: 'تجهيل الملف الشخصي بعد (أشهر بلا إقامة)',
            minFinancialYears: 'الحد الأدنى للاحتفاظ المالي (سنوات)',
            runNow: 'تشغيل الآن',
            lastRun: 'آخر تشغيل',
            lastRunSummary: 'وثائق حُذفت: {{docs}} · ملفات جُهّلت: {{guests}} · مؤجَّلة: {{scheduled}}',
            saved: 'حُفظت إعدادات الاحتفاظ',
            ran: 'نُفّذت وظيفة الاحتفاظ',
        },
        anchors: {
            title: 'مراسي سجل التدقيق',
            hint: 'بصمة سلسلة التدقيق عند إغلاق كل يوم. تُطبع في حزمة التقارير وتُرسل إلى السحابة؛ أي تلاعب لاحق بالقرص يكسر التطابق.',
            date: 'تاريخ العمل',
            hash: 'البصمة',
            count: 'عدد السجلات',
            onPack: 'مرساة سجل التدقيق',
        },
    },
    wizard: {
        title: 'إعداد الفندق (الوضع الخفيف)',
        hint: 'أربع خطوات بلا إنترنت: اسم الفندق، أنواع الغرف، الغرف والسعر، ثم ابدأ العمل. كل شيء قابل للتعديل لاحقاً من شاشات الإعداد.',
        step1: 'الفندق',
        step2: 'أنواع الغرف',
        step3: 'الغرف والأسعار',
        step4: 'جاهز',
        propertyName: 'اسم الفندق',
        currency: 'العملة الأساسية',
        next: 'التالي',
        back: 'رجوع',
        typesHint: 'ضع عدد الغرف لكل نوع (اترك 0 لما لا تملكه). الرقم الأول يولّد الأرقام تلقائياً.',
        typeName: 'النوع',
        occupancy: 'الإشغال',
        count: 'العدد',
        firstNumber: 'أول رقم',
        price: 'السعر/ليلة',
        reviewHint: 'سيُنشأ ما يلي الآن:',
        fromNumber: 'بدءاً من {{n}}',
        roomCount: 'عدد الغرف',
        propertyNameEn: 'الاسم بالإنجليزية (اختياري، يُطبع تحت الاسم العربي)',
        roomsReady: 'الغرف نظيفة وجاهزة لاستقبال النزلاء',
        roomNumbers: 'الأرقام',
        create: 'إنشاء الغرف',
        csvTitle: 'بدلاً من ذلك: استيراد من جدول Excel',
        csvHint: 'حمّل القالب، املأه في Excel، احفظه بصيغة CSV (UTF-8) ثم الصق محتواه هنا.',
        roomsTemplate: 'قالب الغرف',
        guestsTemplate: 'قالب النزلاء',
        csvPaste: 'محتوى الملف',
        importRooms: 'استيراد الغرف',
        imported: 'الغرف المستوردة: {{n}} · الأخطاء: {{errors}}',
        doneTitle: 'الفندق جاهز للعمل',
        doneSummary: 'أنواع الغرف: {{types}} · الغرف: {{rooms}} · الأسعار: {{rates}}',
        doneNext: 'الخطوة التالية: أضف موظفي الاستقبال ورموزهم السرية من شاشة الأمان، ثم افتح شبكة الغرف.',
        openTapeChart: 'فتح شبكة الغرف',
        openSecurity: 'الأمان',
    },
    ar: {
        title: 'الذمم المدينة (حسابات الشركات)',
        navLabel: 'حسابات الشركات',
        accounts: 'الحسابات',
        aging: 'أعمار الديون',
        newAccount: 'حساب شركة جديد',
        editAccount: 'تعديل حساب الشركة',
        code: 'الرمز',
        company: 'الشركة',
        nameEn: 'الاسم (لاتيني)',
        contact: 'جهة الاتصال',
        address: 'العنوان',
        creditLimit: 'حد الائتمان',
        terms: 'مهلة السداد',
        days: 'يوم',
        status: 'الحالة',
        statuses: { active: 'نشط', suspended: 'موقوف', closed: 'مغلق' },
        pickAccount: 'اختر حساباً لعرض الكشف',
        openInvoices: 'فواتير مفتوحة',
        noOpenInvoices: 'لا فواتير مفتوحة',
        due: 'الاستحقاق',
        open: 'المتبقي',
        statement: 'كشف الحساب',
        type: 'النوع',
        types: { invoice: 'فاتورة', payment: 'تحصيل', credit_note: 'إشعار دائن', adjustment: 'تسوية' },
        reference: 'المرجع',
        running: 'الرصيد التراكمي',
        collect: 'تحصيل',
        collectHint: 'يُسجَّل التحصيل في ورديتك المفتوحة ويُخصَّص للفواتير الأقدم أولاً.',
        buckets: { current: 'غير مستحق', d30: '1–30', d60: '31–60', d90: '61–90', over90: '> 90' },
        openTotal: 'إجمالي المفتوح',
        transferTitle: 'تحويل إلى حساب شركة',
        transferHint: 'تُصدر فاتورة نهائية باسم الشركة ويُصفَّر الفوليو بسطر «دفتر المدينة». يلزم الرمز السري.',
        transfer: 'تحويل',
        overrideLimit: 'تجاوز حد الائتمان (يلزم سبب)',
    },
    group: {
        title: 'الحجوزات الجماعية',
        navLabel: 'المجموعات',
        new: 'كتلة جديدة',
        name: 'اسم المجموعة',
        cutoff: 'تاريخ القطع',
        pickup: 'ملتقط / محجوز',
        blocked: 'محجوز',
        pickedUp: 'ملتقط',
        remaining: 'المتبقي',
        pick: 'اختر كتلة لعرض قائمة الأسماء',
        statuses: { active: 'نشطة', released: 'محرَّرة', cancelled: 'ملغاة' },
        roomingList: 'قائمة الأسماء',
        noNames: 'لا أسماء بعد — أضف النزلاء من الأعلى',
        addName: 'إضافة اسم',
        release: 'تحرير غير الملتقط',
        cancel: 'إلغاء الكتلة',
        cancelReason: 'سبب إلغاء الكتلة (الحجوزات الملتقطة تبقى)',
        routing: 'التوجيه',
        routingNone: 'كل غرفة على فوليو نزيلها',
        routingRoom: 'إيجار الغرف على الفوليو الرئيسي',
        masterFolio: 'الفوليو الرئيسي',
        openMaster: 'فتح فوليو رئيسي',
        checkIn: 'تسجيل دخول جماعي',
        checkInDone: 'سُجّل دخول {{ok}} · فشل {{failed}}',
    },
    forecast: {
        title: 'التنبؤ',
        navLabel: 'التنبؤ',
        tag: 'توقع — ليس فعلياً',
        days: 'الأيام',
        weight: 'وزن المؤقت',
        hint: 'المحجوز = مؤكد + مؤقت × الوزن. الالتقاط = متوسط الغرف المضافة في نفس اليوم من الأسبوع خلال آخر {{weeks}} أسابيع. الإيراد = الغرف المتوقعة × متوسط سعر الغرفة من الأسعار المحجوزة.',
        sellable: 'قابلة للبيع',
        otb: 'على الكتب',
        pickup: 'الالتقاط',
        rooms: 'الغرف المتوقعة',
        weeks: 'أسابيع الالتقاط',
        saveDefaults: 'حفظ كمعاملات المنشأة',
    },
    channels: {
        title: 'القنوات والحجز الإلكتروني',
        navLabel: 'القنوات',
        disabled: 'غير مفعّل',
        leaseActive: 'متصل — تأكيد فوري',
        leaseExpired: 'العقد منتهٍ — طلبات فقط',
        delegatedUnits: 'مفوَّض للقنوات: {{n}}',
        pendingUnits: 'بانتظار الوصول: {{n}}',
        lastPush: 'آخر إرسال',
        requests: 'طلبات الحجز',
        requestsHint: 'طلب يصل عندما لا يغطي التفويض الإقامة أو عند انقطاع الاتصال. القبول يتحقق من التوفر مجدداً؛ انتهاء المهلة يُلغي الطلب تلقائياً.',
        noRequests: 'لا طلبات مفتوحة',
        deadline: 'المهلة',
        channel: 'القناة',
        accept: 'قبول',
        reject: 'رفض',
        accepted: 'قُبل الطلب وأصبح حجزاً مؤكداً',
        rejected: 'رُفض الطلب',
        rejectReason: 'سبب الرفض (اختياري)',
        delegation: 'التفويض',
        delegationHint: 'المتبقي = ما يحق للسحابة بيعه فوراً؛ بانتظار الوصول = بيع تم ولم يصل أمره بعد. الاستقبال يرى التوفر ناقص الاثنين. «استرداد» يصفّر التفويض 15 دقيقة.',
        free: 'الحر',
        remaining: 'متبقٍ للقنوات',
        pending: 'بانتظار الوصول',
        desired: 'المطلوب',
        price: 'السعر',
        reclaim: 'استرداد من القنوات',
        reclaimed: 'سيُسترد التفويض خلال ثوانٍ',
        reclaimedUntil: 'مسترد حتى {{t}}',
        settings: 'الإعدادات',
        settingsHint: 'الغرفة الأخيرة تبقى للاستقبال، وحصة القنوات لا تتجاوز النسبة المحددة من كل نوع. السعر المنشور من خطة السعر المختارة.',
        enable: 'نشر التوافر والأسعار للقنوات (تأكيد فوري ضمن التفويض)',
        maxShare: 'الحد الأقصى للتفويض %',
        keepLocal: 'احتفظ بغرفة محلياً عندما الحر ≤',
        sameDayUntil: 'حجز نفس اليوم فورياً حتى الساعة',
        requestTtl: 'مهلة الرد على الطلب (دقائق)',
        horizon: 'أفق النشر (أيام)',
        contactPhone: 'هاتف الفندق (واتساب)',
    },
    update: {
        title: 'تحديثات النظام',
        current: 'الإصدار الحالي',
        available: 'تحديث {{version}} جاهز',
        none: 'لا تحديث متاح. يفحص الوكيل القناة كل 6 ساعات.',
        scheduled: 'سيُثبَّت في نافذة الصيانة (لا تدقيق ليلي جارٍ، نسخة احتياطية موثّقة، ليس على البطارية).',
        applyNow: 'تثبيت الآن',
        applyConfirm: 'سيتوقف النظام دقائق أثناء التثبيت. لا تدقيق ليلي جارٍ؟ لا تُطفئ الخادم. متابعة؟',
        defer: 'تأجيل',
        deferDays: 'تأجيل {{days}}',
        deferred: 'أُجّل التحديث',
        importTitle: 'استيراد حزمة من قرص خارجي',
        importHint: 'مسار مجلد الحزمة على خادم الفندق (يحوي manifest.json و bundle.tar.gz). لا شيء يُثبَّت قبل الضغط على "تثبيت الآن".',
        importPath: 'مسار الحزمة',
        importButton: 'استيراد',
        imported: 'استُوردت الحزمة {{version}}',
        started: 'بدأ التثبيت. تابع الحالة هنا.',
        runs: 'سجل التحديثات',
        states: {
            idle: 'خامل',
            detected: 'اكتُشف',
            verifying: 'تحقق',
            scheduled: 'مجدول',
            downloading: 'تنزيل',
            verified: 'تم التحقق',
            preflight: 'فحوص مسبقة',
            backing_up: 'نسخ احتياطي',
            migrating: 'ترحيل القاعدة',
            switching: 'تبديل الإصدار',
            health_check: 'فحص الصحة',
            done: 'تم',
            rolled_back: 'تراجع',
            failed: 'فشل',
            incompatible: 'غير متوافق',
        },
        banner: {
            available: 'تحديث {{version}} جاهز. سيُثبَّت في نافذة الصيانة أو عند اختيارك.',
            inProgress: 'جارٍ تحديث النظام (≈ 5 دقائق). لا تُطفئ الخادم.',
            rolledBack: 'فشل التحديث وعاد النظام إلى الإصدار السابق. العمل مستمر. أُبلغ الدعم.',
        },
        sync: {
            ok: 'متزامن',
            delayed: 'مزامنة متأخرة',
            offline: 'بلا اتصال بالسحابة',
            unknown: 'غير مفعّل',
            pending: 'أحداث بانتظار المزامنة: {{n}}',
        },
    },
    errors: {
        licenseRestricted: 'هذا الإجراء مقيّد بحالة الترخيص. تسجيل المغادرة والدفعات والتصدير تعمل دائماً.',
        roomCapReached: 'بلغت حد الغرف في الترخيص. للزيادة تواصل مع سيروفا.',
        licenseSignature: 'توقيع الترخيص غير صالح أو المفتاح غير موثوق.',
        licenseMismatch: 'هذا الترخيص لمنشأة أو جهاز آخر.',
        licenseOlder: 'يوجد ترخيص أحدث مطبّق.',
        nodeIdentityMissing: 'لم تُنشأ هوية الجهاز بعد (وكيل العقدة لا يعمل؟).',
        storageFull: 'قرص الخادم ممتلئ. لم تُحفظ العملية. حرّر مساحة ثم أعد المحاولة.',
        dbUnavailable: 'قاعدة البيانات غير متاحة الآن (قد تكون تُعيد التشغيل). أعد المحاولة بعد لحظات.',
        agentUnavailable: 'وكيل العقدة لا يستجيب. تحقّق من خدمة وكيل سيروفا على الخادم.',
        agentBusy: 'الوكيل ينفّذ مهمة أخرى الآن. انتظر انتهاءها.',
        generic: 'حدث خطأ غير متوقع. أعد المحاولة أو تواصل مع الدعم.',
        forbidden: 'ليست لديك صلاحية لهذا الإجراء',
        conflict: 'عُدّل هذا السجل من قبل مستخدم آخر. أعد التحميل.',
        validation: 'تحقّق من الحقول المحددة',
        noAvailability: 'لا توفر للنوع المطلوب في هذه الليالي',
        overbookingConfirm: 'هذا الحجز يتجاوز المخزون المتاح. التأكيد يحتاج صلاحية الحجز الزائد.',
        roomConflict: 'الغرفة محجوزة في هذه الليالي',
        roomNotReady: 'الغرفة غير جاهزة (متسخة)',
        roomNotAssigned: 'عيّن غرفة أولاً',
        identityRequired: 'وثيقة هوية مطلوبة قبل تسجيل الدخول',
        possibleDuplicate: 'يوجد نزيل مشابه',
        noRate: 'لا يوجد سعر معرّف لهذه الليالي',
        creditLimit: 'تجاوز حد الائتمان لحساب الشركة؛ يلزم تجاوز بسبب أو دفع مباشر',
        arSuspended: 'حساب الشركة موقوف؛ يدفع الضيف مباشرة',
        groupFull: 'لا غرف متبقية في الكتلة لهذا النوع؛ زد الكتلة أولاً',
        groupBelowPickup: 'لا يمكن إنقاص الكتلة تحت عدد الملتقط',
        shiftRequired: 'افتح وردية صندوق أولاً',
        channelRatePlan: 'لم تُحدَّد خطة سعر القنوات في إعدادات القنوات',
    },
    search: {
        placeholder: 'ابحث: نزيل، غرفة، رقم تأكيد، هاتف… (Ctrl+K)',
        commands: 'أوامر',
        guestsGroup: 'نزلاء',
        reservationsGroup: 'حجوزات',
        inHouseGroup: 'مقيمون',
        hint: '↑↓ للتنقل، Enter للفتح، Esc للإغلاق',
    },
    shortcuts: {
        title: 'اختصارات لوحة المفاتيح',
        search: 'بحث عام',
        help: 'هذه اللوحة',
        goDashboard: 'لوحة اليوم',
        goArrivals: 'الوصول',
        goDepartures: 'المغادرة',
        goInHouse: 'المقيمون',
        goReservations: 'الحجوزات',
        goTape: 'شبكة الغرف',
        goCashier: 'الصندوق',
        goNightAudit: 'التدقيق الليلي',
        goHousekeeping: 'التدبير الفندقي',
        goGuests: 'النزلاء',
        newItem: 'عنصر جديد',
        walkIn: 'نزيل بدون حجز',
        openSelected: 'فتح المحدد',
        submit: 'حفظ / تأكيد',
        closeDialog: 'إغلاق',
        lock: 'قفل الشاشة',
    },
    dashboard: {
        arrivalsToday: 'وصول اليوم',
        departuresToday: 'مغادرة اليوم',
        inHouseNow: 'مقيمون الآن',
        occupancy: 'الإشغال',
        dirtyRooms: 'غرف متسخة',
        pendingArrivals: 'بانتظار الوصول',
    },
    room: {
        room: 'غرفة',
        rooms: 'الغرف',
        number: 'رقم الغرفة',
        type: 'نوع الغرفة',
        floor: 'الطابق',
        status: 'حالة الغرفة',
        dirty: 'متسخة',
        clean: 'نظيفة',
        inspected: 'مفتّشة',
        ooo: 'خارج الخدمة',
        oos: 'موقوفة',
        occupied: 'مشغولة',
        vacant: 'شاغرة',
        unassigned: 'بلا غرفة',
        pickRoom: 'اختيار غرفة',
        noCandidates: 'لا غرف متاحة من هذا النوع للفترة',
        markClean: 'تعيين نظيفة',
        markDirty: 'تعيين متسخة',
    },
    guest: {
        fatherName: 'اسم الأب',
        motherName: 'اسم الأم',
        birthPlace: 'مكان الولادة',
        scan: {
            button: 'قراءة من صورة الهوية',
            reading: 'جارٍ قراءة الصورة…',
            done: 'قُرئت الهوية: راجع الحقول قبل الحفظ.',
            check: 'تحقّق خاصةً من: {{fields}}',
            failed: 'لم تُعثر على البطاقة في الصورة. صوّر وجه الهوية كاملاً على خلفية داكنة، أو أدخل البيانات يدوياً.',
            error: 'تعذّرت القراءة على هذا الجهاز. أدخل البيانات يدوياً.',
            birthDate: 'تاريخ الولادة',
            nationalNumber: 'الرقم الوطني',
        },
        dangerZone: 'منطقة حساسة',
        documentsHint: 'تُحفظ أرقام الوثائق مشفّرة، وكل اطلاع عليها يُسجَّل.',
        anonymize: 'حذف البيانات الشخصية (تجهيل)',
        anonymizeReason: 'سبب التجهيل',
        anonymizeConfirm: 'سيُستبدل الاسم ويُمسح الهاتف والبريد والوثائق نهائياً، وتبقى الفواتير. متابعة؟',
        anonymized: 'جُهّل الملف الشخصي',
        anonymizeScheduled: 'جُدول التجهيل بتاريخ {{date}} بسبب حد الاحتفاظ المالي',
        anonymizedBadge: 'مجهَّل',
        guest: 'النزيل',
        guests: 'النزلاء',
        profile: 'ملف النزيل',
        nameAr: 'الاسم (عربي)',
        nameLatin: 'الاسم (لاتيني)',
        phone: 'الهاتف',
        email: 'البريد الإلكتروني',
        nationality: 'الجنسية',
        dateOfBirth: 'تاريخ الميلاد',
        gender: 'الجنس',
        male: 'ذكر',
        female: 'أنثى',
        vip: 'كبار الزوار',
        blacklisted: 'قائمة سوداء',
        newGuest: 'نزيل جديد',
        createQuick: 'إنشاء نزيل باسم «{{name}}»',
        typeToSearch: 'اكتب 2 حرفاً على الأقل للبحث',
        duplicateHint: 'يوجد نزلاء مشابهون. اختر واحداً أو أكّد الإنشاء.',
        createAnyway: 'إنشاء على أي حال',
        identity: 'وثيقة الهوية',
        documents: 'الوثائق',
        addDocument: 'إضافة وثيقة',
        docType: 'نوع الوثيقة',
        docNumber: 'رقم الوثيقة',
        issuingCountry: 'بلد الإصدار',
        issueDate: 'تاريخ الإصدار',
        expiryDate: 'تاريخ الانتهاء',
        passport: 'جواز سفر',
        nationalId: 'بطاقة شخصية',
        drivingLicense: 'رخصة قيادة',
        residencePermit: 'إقامة',
        other: 'أخرى',
        reveal: 'إظهار الرقم',
        revealReason: 'سبب الاطلاع',
        encryptedHint: 'يُخزَّن رقم الوثيقة مشفّراً ويُسجَّل كل اطلاع عليه',
        noDocuments: 'لا وثائق مسجّلة',
        stays: 'الإقامات',
    },
    reservation: {
        reservation: 'الحجز',
        reservations: 'الحجوزات',
        confirmation: 'رقم التأكيد',
        status: 'الحالة',
        arrival: 'الوصول',
        departure: 'المغادرة',
        source: 'المصدر',
        ratePlan: 'خطة السعر',
        needGuest: 'اختر نزيلاً أو أنشئه لإكمال الحجز',
        guarantee: 'الضمان',
        tentative: 'مؤقت',
        confirmed: 'مؤكد',
        checked_in: 'مقيم',
        checked_out: 'غادر',
        cancelled: 'ملغى',
        no_show: 'لم يحضر',
        moved: 'نُقل',
        requested: 'طلب حجز',
        roomsSection: 'التواريخ والغرف',
        guestSection: 'النزيل',
        rateSection: 'السعر والضمان',
        notesSection: 'ملاحظات',
        addRoomLine: 'إضافة غرفة',
        removeRoomLine: 'إزالة',
        availability: 'المتاح',
        quote: 'السعر',
        perNight: 'لليلة',
        createTentative: 'حجز مؤقت (يُلغى تلقائياً بعد المهلة)',
        allowOverbooking: 'السماح بالحجز الزائد (صلاحية)',
        create: 'إنشاء الحجز',
        created: 'تم إنشاء الحجز {{number}}',
        walkInMode: 'وضع النزيل بدون حجز: الوصول اليوم ويُسجَّل الدخول فوراً',
        sources: {
            walk_in: 'بدون حجز',
            phone: 'هاتف',
            email: 'بريد',
            whatsapp: 'واتساب',
            website: 'الموقع',
            ota: 'وكيل إلكتروني',
            travel_agent: 'وكالة سفر',
            corporate: 'شركة',
            channel: 'قناة إلكترونية',
            other: 'أخرى',
        },
        guarantees: { none: 'بدون', deposit: 'عربون', company: 'شركة', credit_card: 'بطاقة (مرجع)' },
        assign: 'تعيين غرفة',
        assignAuto: 'تعيين الغرف تلقائياً',
        unassign: 'إلغاء التعيين',
        checkIn: 'تسجيل الدخول',
        checkOut: 'تسجيل الخروج',
        cancelReservation: 'إلغاء الحجز',
        reinstate: 'إعادة التفعيل',
        noShow: 'لم يحضر',
        extend: 'تمديد / تقصير',
        move: 'نقل غرفة',
        undoCheckIn: 'تراجع عن الدخول',
        printConfirmation: 'طباعة التأكيد',
        cancelled_ok: 'أُلغي الحجز',
        timeline: 'السجل',
        searchPlaceholder: 'اسم، رقم تأكيد، هاتف…',
        allStatuses: 'كل الحالات',
        overbookingWarning: 'تنبيه: هذا الحجز يتجاوز المخزون',
        holdExpires: 'ينتهي الحجز المؤقت في',
    },
    checkin: {
        title: 'تسجيل دخول',
        summary: 'ملخص الحجز',
        room: 'الغرفة',
        identity: 'الهوية',
        identityOk: 'وثيقة مسجّلة',
        identityMissing: 'لا وثيقة مسجّلة',
        allowDirty: 'السماح بغرفة متسخة (صلاحية مشرف)',
        allowIdentityPending: 'الدخول مع هوية معلّقة (صلاحية مشرف)',
        allowBeforeArrival: 'دخول مبكر قبل تاريخ الوصول (صلاحية)',
        confirm: 'تأكيد الدخول',
        done: 'تم تسجيل الدخول في الغرفة {{room}}',
        printCard: 'طباعة بطاقة التسجيل',
        registrationCard: 'بطاقة التسجيل',
        guestsOnStay: 'النزلاء في الغرفة',
        sign: 'توقيع النزيل',
        signed: 'وُقّعت البطاقة ✓',
        signTitle: 'توقيع النزيل على بطاقة التسجيل',
        signHint: 'يوقّع النزيل هنا بالإصبع أو القلم أو الفأرة',
        signClear: 'مسح',
        signSave: 'حفظ التوقيع',
        signDone: 'حُفظ توقيع النزيل',
        signTerms: 'بالتوقيع يقرّ النزيل بصحة بيانات بطاقة التسجيل ويوافق على شروط الإقامة.',
    },
    stay: {
        newDeparture: 'المغادرة الجديدة',
        extendHint: 'تُسعَّر الليالي الجديدة بخطة السعر الحالية',
        moveTo: 'إلى الغرفة',
        moveReason: 'سبب النقل',
        reprice: 'تطبيق سعر الغرفة الجديدة',
        moved: 'تم النقل إلى الغرفة {{room}}',
        extended: 'تم تغيير المغادرة إلى {{date}}',
    },
    reasons: {
        guest_request: 'طلب النزيل',
        price: 'السعر',
        duplicate: 'حجز مكرر',
        error: 'خطأ إدخال',
        operational: 'سبب تشغيلي',
        other: 'أخرى',
    },
    tape: {
        allTypes: 'كل الأنواع',
        filterType: 'نوع الغرفة',
        weeks: 'أسبوع',
        title: 'شبكة الغرف',
        days: 'أيام',
        legend: 'المفتاح',
        unassigned: 'حجوزات بلا غرفة',
        clickHint: 'انقر خلية فارغة لحجز جديد، أو حجزاً لفتحه',
    },
    billing: {
        folio: 'الفوليو',
        folios: 'الفوليوهات',
        window: 'نافذة',
        balance: 'الرصيد',
        credit: 'رصيد دائن',
        lines: 'السطور',
        uninvoicedLines: 'سطور غير مفوترة: {{n}}',
        line: 'سطر',
        lineNo: '#',
        description: 'البيان',
        amount: 'المبلغ',
        original: 'الأصلي',
        base: 'بعملة الأساس',
        postedBy: 'بواسطة',
        postedAt: 'وقت الترحيل',
        businessDate: 'تاريخ العمل',
        reversed: 'معكوس',
        reversal: 'عكس',
        active: 'نشط',
        invoiced: 'مفوتر',
        open: 'مفتوح',
        settled: 'مسوّى',
        closed: 'مغلق',
        postCharge: 'ترحيل رسم',
        chargeCode: 'رمز الرسم',
        quantity: 'الكمية',
        unitPrice: 'سعر الوحدة',
        currency: 'العملة',
        takePayment: 'تحصيل دفعة',
        deposit: 'وديعة',
        payment: 'دفعة',
        method: 'طريقة الدفع',
        methods: { cash: 'نقداً', card: 'بطاقة', bank_transfer: 'تحويل بنكي', other: 'أخرى' },
        tenderCurrency: 'عملة الدفع',
        received: 'المبلغ المستلم',
        changeCurrency: 'عملة الباقي',
        changeDue: 'الباقي للضيف',
        rateApplied: 'سعر الصرف المطبّق',
        equivalent: 'المعادل',
        remaining: 'المتبقي بعد الدفع',
        methodDetail: 'مرجع (رقم العملية)',
        receivedFrom: 'استُلم من',
        receipt: 'إيصال',
        receiptNo: 'رقم الإيصال',
        refund: 'استرداد',
        requestRefund: 'طلب استرداد',
        refundPending: 'طلب الاسترداد بانتظار موافقة مشرف',
        refundPosted: 'تم الاسترداد — إيصال {{receipt}}',
        discount: 'خصم',
        postDiscount: 'خصم على السطر',
        percent: 'نسبة %',
        discountPending: 'الخصم بانتظار موافقة مشرف',
        reverse: 'عكس السطر',
        reverseConfirm: 'سيُضاف سطر عكسي بنفس المبلغ بإشارة معاكسة (لا حذف).',
        transfer: 'نقل إلى نافذة',
        transferTo: 'النافذة الهدف',
        newWindow: 'نافذة جديدة',
        ownerLabel: 'اسم النافذة',
        ownerType: 'المالك',
        owners: { guest: 'النزيل', company: 'شركة', house: 'الفندق' },
        closeFolio: 'إغلاق الفوليو',
        invoice: 'فاتورة',
        proforma: 'فاتورة أولية',
        issueFinal: 'إصدار فاتورة نهائية',
        issueProforma: 'فاتورة أولية (بدون ترقيم نهائي)',
        issueConfirm: 'سيُخصَّص رقم تسلسلي لا يمكن إلغاؤه إلا بإشعار دائن.',
        billTo: 'الفاتورة باسم',
        taxId: 'الرقم الضريبي',
        invoices: 'الفواتير',
        creditNote: 'إشعار دائن',
        creditNoteFull: 'إشعار دائن كامل (إلغاء الفاتورة)',
        invoiceStatus: {
            proforma: 'أولية',
            issued: 'صادرة',
            partially_credited: 'مخفَّضة جزئياً',
            fully_credited: 'ملغاة بإشعار دائن',
        },
        totalNet: 'الصافي',
        serviceCharge: 'رسم الخدمة',
        tax: 'الضريبة',
        totalGross: 'الإجمالي',
        paid: 'المدفوع',
        due: 'المستحق',
        selectLine: 'اختر سطراً أولاً',
        checkOut: 'تسجيل مغادرة',
        checkOutConfirm: 'سيُغلق الفوليو وتُحرَّر الغرفة (متسخة).',
        earlyDeparture: 'مغادرة مبكرة قبل تاريخ المغادرة — تأكيد التقصير',
        balanceNotZero: 'يجب تسوية الرصيد قبل الخروج',
        checkedOut: 'تم تسجيل المغادرة',
        reopenStay: 'إعادة فتح الإقامة',
        pinTitle: 'تأكيد بالرمز السري',
        pinHint: 'العمليات المالية تتطلب إعادة المصادقة بالرمز السري',
        noShift: 'لا وردية مفتوحة — افتح وردية أولاً',
        openShiftLink: 'فتح وردية',
        postDeparture: 'بعد المغادرة',
    },
    cashier: {
        closedBySupervisor: 'أغلقها المشرف',
        reopenCount: 'مرات إعادة الفتح: {{n}}',
        title: 'الصندوق',
        shift: 'الوردية',
        noShift: 'لا وردية مفتوحة',
        openShift: 'فتح وردية',
        closeShift: 'إغلاق الوردية',
        openingFloat: 'العهدة الافتتاحية',
        addCurrency: 'إضافة عملة',
        blindCount: 'العدّ الأعمى',
        blindHint: 'أدخل المعدود لكل عملة؛ المتوقع لا يظهر قبل الإرسال.',
        counted: 'المعدود',
        expected: 'المتوقع',
        variance: 'الفرق',
        varianceReason: 'سبب الفرق',
        varianceReasonRequired: 'الفرق يتجاوز التسامح — السبب مطلوب',
        closed: 'أُغلقت الوردية',
        opened: 'فُتحت الوردية',
        reopen: 'إعادة فتح',
        byMethod: 'حسب طريقة الدفع',
        shifts: 'الورديات',
        status: { open: 'مفتوحة', closing: 'قيد الإغلاق', closed: 'مغلقة', carried: 'مرحَّلة' },
        report: 'تقرير الوردية',
        approvals: 'الموافقات',
        pending: 'معلّقة',
        approve: 'موافقة',
        reject: 'رفض',
        requestedBy: 'الطالب',
        decidedBy: 'الموافق',
        kinds: { refund: 'استرداد', discount: 'خصم', shift_reopen: 'إعادة فتح وردية' },
        decided: 'تم تسجيل القرار',
        user: 'المستخدم',
    },
    audit: {
        run: 'سير التدقيق',
        title: 'التدقيق الليلي',
        history: 'سجل التشغيلات',
        businessDate: 'تاريخ العمل الحالي',
        nextDate: 'تاريخ العمل الجديد',
        prechecks: 'الفحوصات المسبقة',
        checks: {
            'PC-01': 'مغادرات لم يُسجَّل خروجها',
            'PC-02': 'وصولات غير معالجة (تُعالَج كعدم حضور)',
            'PC-03': 'ورديات مفتوحة',
            'PC-04': 'موافقات معلّقة',
            'PC-05': 'عملات بلا سعر صرف',
        },
        override: 'تجاوز بسبب',
        overridden: 'مُتجاوَز',
        start: 'بدء التدقيق',
        startConfirm: 'سيُقفل تاريخ العمل {{date}} ويتقدّم إلى {{next}}. لا يمكن التراجع.',
        resume: 'استئناف',
        blocked: 'محجوب — حلّ العوائق أو تجاوزها',
        running: 'جارٍ…',
        failed: 'فشل',
        completed: 'مكتمل',
        completed_with_overrides: 'مكتمل مع تجاوزات',
        steps: {
            'NA-01': 'الفحوصات المسبقة',
            'NA-02': 'ترحيل رسوم الغرف والضرائب',
            'NA-03': 'معالجة عدم الحضور',
            'NA-04': 'الورديات والموافقات',
            'NA-05': 'تجميد اليوم وتقديم التاريخ',
            'NA-06': 'ترحيل التدبير والصيانة لليوم الجديد',
            'NA-07': 'حزمة التقارير',
            'NA-08': 'الإغلاق والنسخ الاحتياطي',
        },
        counters: {
            roomChargesPosted: 'رسوم غرف مرحَّلة',
            roomChargesSkipped: 'مرحَّلة سابقاً',
            noShows: 'عدم حضور',
            depositForfeits: 'ودائع مصادرة',
            shiftsCarried: 'ورديات مرحَّلة',
            approvalsExpired: 'موافقات منتهية',
            staysAutoExtended: 'إقامات مُددت تلقائياً',
            hkRoomsReset: 'غرف أُعيدت متسخة',
            hkDeparture: 'مهام مغادرة',
            hkStayover: 'مهام إقامة',
            hkVacantDirty: 'مهام شاغرة متسخة',
            oooActivated: 'غرف خرجت من الخدمة',
            oooEnded: 'غرف عادت للخدمة',
        },
        printPack: 'طباعة حزمة التدقيق',
        adminRollover: 'ترحيل إداري للتاريخ (بدون ترحيل رسوم)',
        noActive: 'لا تشغيل جارٍ',
        done: 'اكتمل التدقيق الليلي — التاريخ الجديد {{date}}',
    },
    reports: {
        title: 'التقارير',
        dailyPack: 'الحزمة اليومية',
        ownerSummary: {
            button: 'ملخص المالك عبر واتساب',
            title: 'ملخص المالك عبر واتساب',
            hint: 'يُفتح واتساب على هذا الجهاز والرسالة جاهزة؛ راجعها واضغط إرسال هناك.',
            phone: 'رقم واتساب المالك',
            phoneHint: 'بالصيغة الدولية بلا +، مثل 963933123456؛ يُحفظ للمرة القادمة. اتركه فارغاً لاختيار المحادثة يدوياً.',
            text: 'نص الرسالة',
            open: 'فتح واتساب',
        },
        source: { snapshot: 'لقطة التدقيق', live: 'حي' },
        flash: 'ملخص المدير',
        roomsSold: 'غرف مباعة',
        occupancy: 'الإشغال',
        adr: 'متوسط سعر الغرفة',
        revpar: 'الإيراد لكل غرفة متاحة',
        roomRevenue: 'إيراد الغرف',
        revenueJournal: 'دفتر الإيراد اليومي',
        reconciled: 'متطابق',
        notReconciled: 'غير متطابق',
        payments: 'الدفعات حسب الطريقة',
        shifts: 'الورديات',
        deposits: 'الودائع',
        exceptions: 'استردادات وعكوس وخصومات',
        invoices: 'الفواتير والإشعارات',
        gaps: 'فجوات',
        noShows: 'عدم حضور وإلغاءات',
        openFolios: 'فوليوهات مفتوحة',
        rates: 'أسعار الصرف السارية',
        auditExceptions: 'استثناءات التدقيق',
        taxes: 'التقرير الضريبي',
        exportCsv: 'تصدير ملف جدول',
        group: 'المجموعة',
        count: 'العدد',
    },
    hk: {
        title: 'التدبير الفندقي',
        board: 'لوحة الغرف',
        myTasks: 'مهامي',
        tasks: 'المهام',
        task: 'مهمة',
        generate: 'توليد مهام اليوم',
        generated: 'تم توليد المهام',
        distribute: 'توزيع المهام',
        assign: 'تعيين',
        assignee: 'العامل',
        unassigned: 'غير معيّنة',
        types: {
            departure: 'مغادرة',
            stayover: 'إقامة مستمرة',
            vacant_dirty: 'شاغرة متسخة',
            manual: 'يدوية',
        },
        status: {
            pending: 'بانتظار',
            in_progress: 'جارية',
            done: 'منجزة',
            rejected: 'مرفوضة',
            inspected: 'مفتّشة',
            cancelled: 'ملغاة',
            inspected_skipped: 'تخطي الفحص',
        },
        start: 'بدء',
        finish: 'إنهاء',
        inspectOk: 'قبول الفحص',
        reject: 'رفض',
        rejectReason: 'سبب الرفض',
        cancel: 'إلغاء المهمة',
        dnd: 'لا إزعاج',
        returnLater: 'أعِد لاحقاً',
        markDirty: 'متسخة',
        markClean: 'نظيفة',
        markInspected: 'مفتّشة',
        occupied: 'مشغولة',
        vacant: 'شاغرة',
        arriving: 'وصول اليوم',
        departing: 'مغادرة اليوم',
        floor: 'الطابق',
        allFloors: 'كل الطوابق',
        discrepancy: 'تقرير التباين',
        observed: 'الملاحظة الفيزيائية',
        observedOptions: { occupied: 'مشغولة', vacant: 'شاغرة', sleep_out: 'لم يَبِت', skip: 'تخطٍ' },
        kinds: {
            ok: 'مطابق',
            possible_sleep_out: 'احتمال مبيت خارجي',
            unregistered_guest: 'نزيل غير مسجّل',
            skip: 'تخطٍ',
        },
        resolve: 'حلّ',
        resolution: 'القرار',
        reportIssue: 'إبلاغ عطل',
        newTask: 'مهمة جديدة',
        attendants: 'عمال التدبير',
        saved: 'تم الحفظ',
        noTasks: 'لا مهام',
        pickAttendants: 'اختر العمال للتوزيع',
    },
    mnt: {
        startWork: 'بدء العمل',
        title: 'الصيانة',
        tickets: 'التذاكر',
        newTicket: 'تذكرة جديدة',
        kind: 'النوع',
        kinds: { ticket: 'تذكرة', out_of_order: 'خارج الخدمة', out_of_service: 'موقوفة' },
        titleField: 'العنوان',
        location: 'الموقع (منطقة عامة)',
        priority: 'الأولوية',
        priorities: { low: 'منخفضة', normal: 'عادية', high: 'عالية', urgent: 'عاجلة' },
        status: { open: 'مفتوحة', in_progress: 'جارية', resolved: 'محلولة', closed: 'مغلقة' },
        range: 'نطاق التواريخ',
        affected: 'حجوزات متأثرة',
        affectedHint: 'هذه الحجوزات معيّنة على الغرفة ضمن النطاق؛ سيُلغى تعيينها عند التأكيد.',
        unassignConfirm: 'إلغاء تعيين الحجوزات المتأثرة والمتابعة',
        resolve: 'حلّ التذكرة',
        resolutionNote: 'ملاحظة الحل',
        reporter: 'المبلِّغ',
        report: 'الغرف خارج الخدمة',
        lostNights: 'ليالٍ مفقودة',
        created: 'أُنشئت التذكرة',
        occupiedError: 'الغرفة مشغولة — انقل النزيل أولاً',
    },
    handover: {
        title: 'تسليم الوردية',
        notes: 'الملاحظات',
        newNote: 'ملاحظة جديدة',
        kind: 'النوع',
        kinds: { info: 'معلومة', follow_up: 'متابعة', incident: 'حادثة' },
        department: 'القسم',
        departments: {
            front_office: 'الاستقبال',
            housekeeping: 'التدبير',
            finance: 'المالية',
            maintenance: 'الصيانة',
            fnb: 'الأغذية',
            management: 'الإدارة',
        },
        body: 'النص',
        acknowledge: 'إقرار بالاستلام',
        acknowledged: 'مُقرّ',
        close: 'إغلاق',
        closeComment: 'تعليق الإغلاق',
        pendingTitle: 'ملاحظات بانتظار إقرارك',
        pendingHint: 'أقرّ باستلام كل ملاحظة قبل المتابعة.',
        summary: 'ملخص التسليم',
        printSummary: 'طباعة ملخص التسليم',
        arrivalsRemaining: 'وصولات متبقية',
        departuresRemaining: 'مغادرات متبقية',
        roomsNotReady: 'غرف غير جاهزة',
        open: 'مفتوحة',
        closed: 'مغلقة',
        author: 'الكاتب',
    },
    dash: {
        arrivals: 'الوصول (متوقع/تم)',
        departures: 'المغادرة (متوقع/تم)',
        ready: 'غرف جاهزة',
        ooo: 'خارج الخدمة / موقوفة',
        unassignedArrivals: 'وصولات بلا غرفة',
        departuresWithBalance: 'مغادرات برصيد',
        overdue: 'إقامات متأخرة',
        tentativeExpiring: 'حجوزات مؤقتة تنتهي',
        alerts: 'تنبيهات',
        overbooking: 'حجز زائد {{code}} ليلة {{night}} (+{{over}})',
        discrepancies: 'تباينات التدبير: {{n}}',
        incidents: 'حوادث مفتوحة: {{n}}',
        auditOverdue: 'التدقيق الليلي لم يُشغَّل: تاريخ العمل {{date}} والتقويم {{today}}',
        revenueToday: 'إيراد اليوم',
        noAlerts: 'لا تنبيهات',
    },
    auditLog: {
        title: 'سجل التدقيق',
        user: 'المستخدم',
        action: 'الإجراء',
        entity: 'الكيان',
        entityId: 'المعرّف',
        before: 'قبل',
        after: 'بعد',
        sensitiveOnly: 'الحساسة فقط',
        export: 'تصدير ملف جدول',
        timeline: 'السجل الزمني',
    },
    print: {
        paper: 'ورق الطباعة على هذا الجهاز',
        paperA4: 'A4',
        paper80: 'حراري 80 مم',
        hotel: 'الفندق',
        registrationCard: 'بطاقة تسجيل نزيل',
        confirmation: 'تأكيد حجز',
        signature: 'توقيع النزيل',
        receivedFrom: 'استلمنا من',
        paidAt: 'تاريخ الدفع',
        cashierSignature: 'توقيع أمين الصندوق',
        guestSignature: 'توقيع النزيل',
        printedAt: 'طُبع في',
        signedAt: 'وقّع في',
        terms: 'بالتوقيع أدناه يقرّ النزيل بصحة البيانات ويوافق على شروط الإقامة.',
    },
};
//# sourceMappingURL=ar.js.map